import { useCallback, useMemo, useRef } from 'react'

import { useGetRouteBusStops } from '@/modules/CombinedLogs/api/useGetRouteBusStops'
import { useWorkstationStore } from '@/modules/Workstation/store'
import { useGarageStore } from '@/modules/FindGarage'
import { useReaderLogStore } from '@/modules/FindControllerLog/store'
import { useAuthStore } from '@/store/auth-store'
import { Role } from '@/types/auth'

export const useBusStops = () => {
    const { role } = useAuthStore()
    const { routes: workstationRoutes } = useWorkstationStore()
    const { garage } = useGarageStore()
    const { source } = useReaderLogStore()

    const routes = useMemo(() => {
        if (role === Role.Controller) {
            return workstationRoutes.map((item) => item.route)
        }

        if (role === Role.PerformanceManager) {
            return workstationRoutes.map((item) => item.route)
        }

        if (garage && role === Role.MileageClerk) {
            return garage.routes
        }

        if (source && role === Role.Reader) {
            return source.routes.map((item) => item.route)
        }

        return []
    }, [role, workstationRoutes, garage, source])

    const emptyBusStops = useRef([])

    const { data: busStops = emptyBusStops.current } = useGetRouteBusStops(role !== Role.Controller, routes)
    const allStops = useMemo(() => busStops.flatMap((item) => [...item.outbound, ...item.inbound]), [busStops])

    const getRouteBusStops = useCallback(
        (route?: string) => {
            return route && busStops.find((item) => item.route === route)
        },
        [busStops]
    )

    return { allStops, getRouteBusStops }
}
